import CategoryPageLayout from "@/components/CategoryPageLayout";
import outdoor1 from "@/assets/outdoor-1.jpg";
import outdoor2 from "@/assets/outdoor-2.jpg";
import outdoor3 from "@/assets/outdoor-3.jpg";
import outdoor4 from "@/assets/outdoor-4.jpg";
import outdoor5 from "@/assets/outdoor-5.jpg";
import outdoor6 from "@/assets/outdoor-6.jpg";

const subcategories = [
  { image: outdoor1, title: "Pergole bioclimatiche", description: "Lamelle orientabili, comfort tutto l'anno", slug: "pergole" },
  { image: outdoor2, title: "Tende da sole", description: "Protezione solare retrattile e resistente", slug: "tende-sole" },
  { image: outdoor3, title: "Gazebi", description: "Spazi living all'aperto, eleganti e funzionali", slug: "gazebi" },
  { image: outdoor4, title: "Tettoie", description: "Coperture architettoniche per ingressi e terrazze", slug: "tettoie" },
  { image: outdoor5, title: "Arredi esterni", description: "Complementi per un risultato completo", slug: "arredi" },
  { image: outdoor6, title: "Chiusure verticali", description: "Privacy e protezione dal vento e dal sole", slug: "chiusure" },
];

const OutdoorPage = () => (
  <CategoryPageLayout
    heading="Outdoor & Soluzioni Ombra"
    subtitle="Più spazio da vivere all'aperto, tutto l'anno. Pergole, tende, tettoie e gazebi su misura."
    basePath="/outdoor"
    subcategories={subcategories}
  />
);

export default OutdoorPage;
